import { AgentCommissionProgressList } from './agentCommissionProgressList';

// Personal MOC page for users who receive Manager Override Commissions.
// AgentCommissionProgressList already filters /commissions endpoint rows
// by commPayType (matching MOC + MOC/2 via prefix), so this is just a
// thin wrapper for routing purposes (mirrors how PSC/DOC/TOC are routed).
export default function MocList() {
    return <AgentCommissionProgressList commPayType="MOC" />;
}
